<template>
    <button
        type="button"
        class="card flex w-full items-start gap-3 p-3 text-left"
        aria-haspopup="dialog"
        @click="$emit('click')"
    >
        <CompanyDiaryTypeBadge :type="entry.type" />
        <div class="flex min-w-0 grow flex-col gap-1">
            <div class="flex items-start justify-between gap-3">
                <div class="min-w-0">
                    <div class="truncate font-medium">{{ entry.title }}</div>
                    <div class="truncate text-xs text-muval-gray-2">
                        {{ entry.type.name || 'Uncategorised' }}
                    </div>
                </div>
                <Lozenge
                    :class="companyDiaryStatusClasses(entry.status)"
                    class="shrink-0 text-xs"
                >
                    {{ companyDiaryStatusLabel(entry.status) }}
                </Lozenge>
            </div>
            <div class="flex items-center gap-1.5 text-xs text-muval-gray-2">
                <SvgIcon
                    name="system-calendar"
                    class="size-4 shrink-0"
                />
                <span>{{ windowLabel }}</span>
            </div>
        </div>
    </button>
</template>

<script setup lang="ts">
import dayjs from 'dayjs';
import type { MyCompanyDiaryActivity } from '@/composables/useMyOrderActions';
import Lozenge from '@components/Lozenge.vue';
import CompanyDiaryTypeBadge from '@components/company-diary/CompanyDiaryTypeBadge.vue';
import {
    companyDiaryStatusClasses,
    companyDiaryStatusLabel,
} from '@components/company-diary/companyDiaryStatusOptions';
import SvgIcon from '@components/utilities/SvgIcon.vue';

const props = defineProps<{ entry: MyCompanyDiaryActivity }>();

defineEmits<{ click: [] }>();

const windowLabel = computed(() => {
    const start = dayjs(props.entry.start_datetime);
    const end = dayjs(props.entry.end_datetime);

    if (props.entry.all_day) {
        return start.isSame(end, 'day') ? 'All day' : `${start.format('D MMM')} - ${end.format('D MMM')} · All day`;
    }

    return start.isSame(end, 'day') ?
            `${start.format('h:mm A')} - ${end.format('h:mm A')}`
        :   `${start.format('D MMM, h:mm A')} - ${end.format('D MMM, h:mm A')}`;
});
</script>
